import { ArrayField, Text } from 'informed';
import * as React from 'react';

import GeneralConstants from '../../../constants/general.constants';
import CommentFormDisplay from '../../comments/comment-form-display.component';

import api from '../../../services/api.service';

class ProjectExtrasMultiform extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            group: this.props.group,
            getInitialValues: this.props.getInitialValues,
            products: this.props.products,
            handleProductRemove: this.props.handleProductRemove,
            activeFormDataStatus: this.props.activeFormDataStatus,
            extraClass: true
        };
    }

    componentDidMount() {
        // Try different ways to access the emitter
        if (this.props.formApi?.emitter?.setMaxListeners) {
            this.props.formApi.emitter.setMaxListeners(30);
        }
        
        if (this.props.formContext?.emitter?.setMaxListeners) {
            this.props.formContext.emitter.setMaxListeners(30);
        }
        
        // For global EventEmitter default
        try {
            require('events').defaultMaxListeners = 30;
        } catch (e) {
            console.log('Could not set defaultMaxListeners');
        }
    }

    // Fix the ArrayField rendering to prevent memory leaks
    renderArrayField = () => {
        return (
            <ArrayField
                field={`${this.props.group}.list.items`}
                initialValue={this.props.getInitialValues(`${this.props.group}.list.items`)}
                key={`${this.props.group}-array-${Date.now()}`} // Add a unique key
                removeOnUnmount={true} // Important - remove listeners on unmount
            >
                {/* Your existing ArrayField content */}
            </ArrayField>
        );
    };

	triggerComment = (path, group, iteration, label) => {
		if (
			this.props.products[`${group}`].list.items.value[`${iteration}`] &&
			this.props.products[`${group}`].list.items.value[`${iteration}`].id
		) {
			this.state.handleShowComments({
				targetId: path + this.props.products[`${group}`].list.items.value[`${iteration}`].id,
				group: 'products',
				label
			});
		} else {
		}
	};

	getId = (group, iteration) => {
		if (
			this.props.products[`${group}`].list.items.value[`${iteration}`] &&
			this.props.products[`${group}`].list.items.value[`${iteration}`].id
		) {
			return this.props.products[`${group}`].list.items.value[`${iteration}`].id;
		}
	};

	getCommentCount = (path, id) => {
		return this.props.comments.filter((comment) => comment.target_id == `${path}${id}`);
	};

	render() {
		const { group, getInitialValues, products, handleProductRemove, activeFormDataStatus } = this.state;

		return (
			<ArrayField field={`products[${group}][list][items][value]`} initialValue={getInitialValues(group)}>
				{({ add, fields }) => (
					<>
						{fields.map(({ field, key, remove, initialValue }, i) => (
							<div className='local-grid local-grid--col-2 separate-line' key={key}>
								<Text
									type='hidden'
									field={`${field}.id`}
									initialValue={
										initialValue && initialValue.id ? initialValue.id : api.forms.getUniqueID()
									}
								/>
								{products[`${group}`].list.pattern.diverse ? (
									<label className='grid-item'>
										<span className='input-description'>
											{products[`${group}`].list.pattern.diverse.label}
										</span>
										<Text
											type='text'
											field={`${field}.diverse`}
											initialValue={
												initialValue && initialValue.diverse ? initialValue.diverse : ''
											}
											allowEmptyString
										/>
									</label>
								) : null}
								{products[`${group}`].list.pattern.EL_pillar ? (
									<label className='grid-item'>
										<span className='input-description'>
											{products[`${group}`].list.pattern.EL_pillar.label}
										</span>
										<Text
											type='text'
											field={`${field}.EL_pillar`}
											initialValue={
												initialValue && initialValue.EL_pillar ? initialValue.EL_pillar : ''
											}
											allowEmptyString
										/>
									</label>
								) : null}
								<label className='grid-item'>
									<span className='input-description'>
										{products[`${group}`].list.pattern.quantity.label}
									</span>
									<Text
										type='number'
										field={`${field}.quantity`}
										min='1'
										initialValue={initialValue && initialValue.quantity ? initialValue.quantity : 1}
										allowEmptyString
									/>
								</label>
								<label className='grid-item'>
									<span className='input-description'>
										{products[`${group}`].list.pattern.delivery_date.label}
									</span>
									<Text
										type='date'
										field={`${field}.delivery_date`}
										allowEmptyString
										initialValue={
											initialValue && initialValue.delivery_date ? initialValue.delivery_date : ''
										}
									/>
								</label>
								<div className='comment-wrapper-fit'>
									<CommentFormDisplay
										targetId={
											initialValue && initialValue.id
												? `products.${products[`${group}`].list.pattern.delivery_date.label}.${
														initialValue.id
												  }`
												: `products.${
														products[`${group}`].list.pattern.delivery_date.label
												  }.${this.getId(group, i)}`
										}
									/>
								</div>
								{i !== 0 && (
									<div className='btn-container btn-container--right'>
										{activeFormDataStatus === 'ready' ? (
											<button className='btn-delete' title={GeneralConstants['delete']} disabled>
												{GeneralConstants['delete']}
											</button>
										) : (
											<button
												className='btn-delete'
												type='button'
												title={GeneralConstants['delete']}
												onClick={(ev) =>
													handleProductRemove(remove, initialValue, [`${group}`])
												}
											>
												{GeneralConstants['delete']}
											</button>
										)}
									</div>
								)}
							</div>
						))}
						<div className='btn-container btn-container--right'>
							<button
								className='btn small light add'
								type='button'
								title={`${GeneralConstants['add']} ${products[`${group}`].label}`}
								onClick={add}
							>
								{`${GeneralConstants['add']} ${products[`${group}`].label}`}
							</button>
						</div>
					</>
				)}
			</ArrayField>
		);
	}
}

export default ProjectExtrasMultiform;
